import React, { useCallback } from 'react';
import { usePhoneActions } from '../../hooks/use-phone';
import Numpad from '../numpad';

export default function Keypad(props: { sendDTMF?: boolean; callId: string; interceptKeyboard?: boolean }) {
    const { sendDTMF, playTones } = usePhoneActions();

    const handleOnChar = useCallback(
        (ch: string) => {
            if (props.sendDTMF && props.callId) {
                sendDTMF(props.callId, ch);
            }
            playTones(ch);
        },
        [props.sendDTMF, props.callId, playTones, sendDTMF]
    );

    return (
        <div data-testid='keypad-div'>
            <Numpad onChar={handleOnChar} interceptKeyboard={props.interceptKeyboard} numberField='text' />
        </div>
    );
}
